import {
  AccountInfo,
  Alarm,
  AlarmOptions,
  DeviceDetails,
  IdleState,
  Manifest,
  NetworkDetails,
  ProfileDetails,
  UserInfo,
} from './extension-api.interfaces';

export abstract class IExtensionApiStrategy {
  public abstract getAlarm(triggerId: string): Promise<Alarm>;
  public abstract createAlarm(triggerId: string, options: AlarmOptions): Promise<void>;
  public abstract clearAlarm(triggerId: string): Promise<boolean>;
  public abstract clearAllAlarms(): Promise<boolean>;
  public abstract getAllAlarms(): Promise<Alarm[]>;
  public abstract addAlarmListener(listener: (alarm: Alarm) => void): void;
  public abstract onInstalled(callback: () => void): void;
  public abstract onStartup(callback: () => void): void;
  public abstract getIdleState(detectionIntervalInSeconds: number): Promise<IdleState>;
  public abstract setIdleStateDetectionInterval(intervalInSeconds: number): void;
  public abstract addIdleStateChangeListener(listener: (newState: IdleState) => void): void;
  public abstract setLocalStorage(items: { [key: string]: any }): Promise<void>;
  public abstract getLocalStorage<T>(keys: string | string[] | { [key: string]: any } | null): Promise<T>;
  public abstract removeLocalStorage(keys: string | string[]): Promise<void>;
  public abstract clearLocalStorage(): Promise<void>;
  public abstract getUserProfile(details: ProfileDetails): Promise<UserInfo>;
  public abstract setUserSignInListener(listener: (account: AccountInfo, signedIn: boolean) => void): void;
  public abstract getManifest(): Manifest;
  public abstract getDevice(): Promise<DeviceDetails>;
  public abstract getNetworkDetails(): Promise<NetworkDetails>;
  public abstract showNotification(notificationId: string, options: unknown): void;
  public abstract clearNotification(notificationId: string): void;
  public abstract setNotificationListener(
    listener: (notificationId: string, buttonIndex: number) => Promise<void>
  ): void;
  public abstract createTab(urlOrOptions: string | Record<string, string>): Promise<void | unknown>;
  public abstract sendMessage(message: string): Promise<unknown>;
  public abstract addMessageListener(messageToWatch: string, handlerFunction: () => unknown): void;
  public abstract clearStorage(): Promise<void>;
  public abstract reloadExtension(): Promise<void>;
  public abstract getExtensionId(): string;
  public abstract setIconBadge({
    backgroundColor,
    text,
    textColor,
  }: {
    backgroundColor: string;
    text: string;
    textColor: string;
  }): Promise<void>;
}
